import {createSlice} from '@reduxjs/toolkit'
import {
  createProgram,
  editProgram,
  getProgramDetail
} from "@/store/program-detail/action";

const initialState = {
  state: null,
  loading: true,
  error: ''
} as BaseState<Program>

const slice = createSlice({
  name: 'programDetailSlice',
  initialState,
  reducers: {
    resetProgramDetail: () => ({ ...initialState })
  },
  extraReducers: (builder) => {
    // create program
    builder.addCase(createProgram.pending, (state) => ({
      ...state,
      loading: true,
      error: null
    }))
    builder.addCase(createProgram.fulfilled, (state) => ({
      ...state,
      loading: false,
      error: null
    }))
    builder.addCase(createProgram.rejected, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to create program'
    }))
  
    // edit program
    builder.addCase(editProgram.pending, (state) => ({
      ...state,
      loading: true,
      error: null
    }))
    builder.addCase(editProgram.fulfilled, (state) => ({
      ...state,
      loading: false,
      error: null
    }))
    builder.addCase(editProgram.rejected, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to create program'
    }))
    
    // get program detail
    builder.addCase(getProgramDetail.pending, (state) => ({
      ...state,
      loading: true,
      error: null
    }))
    builder.addCase(getProgramDetail.fulfilled, (state, action) => ({
      state: action.payload,
      loading: false,
      error: null
    }))
    builder.addCase(getProgramDetail.rejected, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to create program'
    }))
  }
})

export const programDetailActions = slice.actions

export default slice
